/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    
    description:
      'Visit To Lalbagh Flower Show',
    href : '/class-6-field-trip-2024'
 
  },
  {
    
    description:
      'Rocksport 3-4 Field Trip',
    href : '/inhouse-adventure-camp-2024'
 
  },
  {
    
    description:
      'Class 5 Field Trip',
    href : '/visit-to-bhagyalakshmi-farm-2024'
 
  },
  {
    
    description:
      'Class 6 Field Trip',
    href : '/visit-to-eagle-unbound-resort-2024'
 
  },
  {
    
    description:
      'Class 7 Field Trip',
    href : '/visit-to-suggee-resort-2024'
 
  },
  {
    
    description:
      'Class 8 Field Trip',
    href : '/visit-to-infantry-vama-2024'
 
  },
  {
    
    description:
      'Class 9 Field Trip',
    href : '/visit-to-amegundi-2024'
 
  },
  {
    
    description:
      'Class 10 Field Trip',
    href : '/visit-to-kaadgal-resort-2024'
 
  },
  {
    
    description:
      'Class 11 Field Trip',
    href : '/visit-to-rds-nature-retreat-resort-2024'
 
  },
  {
    
    description:
      'Class 11 Isro',
    href : '/visit-to-u-r-rao-satellite-centre-2024'
 
  },
  {
    
    description:
      'Class 11 And 12 Factory Visit',
    href : '/visit-to-mysore-sandal-soap-factory-2024'
 
  },
  {
    
    description:
      'Class 12 Field Trip',
    href : '/visit-to-area-83-2024'
 
  },
  {
    
    description:
      'IISC 2024',
    href : '/visit-to-iisc-2024'
 
  },
  
  
];

const Sidebar2024 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Extracurricular Activities 2024-25
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'P'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2024;
